/* eslint-disable */
export default class pdf {
  static Save(dom, docName) {
    var pdf = new jsPDF();
    let obj = document.getElementById(dom);

    html2canvas(obj)
    .then((canvas) => {
        let img = canvas.toDataURL("image/png");
        pdf.addImage(img, 'JPEG', 40, 20);
        pdf.save(`comprovante_${docName}.pdf`);
    })
  }

  static Print(dom, docName) {
    let obj = document.getElementById(dom);
    let w = window.open("", "_blank");

    html2canvas(obj)
    .then((canvas) => {
        let srcCanvas = canvas.toDataURL("image/png");
        let img = new Image()
        img.src = srcCanvas.toString();

        let html = `<html>
            <head>
                <title>Comprovante_${docName}</title>
            </head>
            <body style="text-align: center;">
              <img src="${img.src}" style="display: inline-block;" onload="print()"/>
            </body>
          </html>`

        w.document.write(html);
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/pdf-helper.js